export default {
	path: '/main',
	redirect: '/main',
	component: () => import('@/views/layout/Default'),
	children: [
		{
			path: '/',
			name: 'mainHome',
			component: () => import('@/views/main/Main'),
		},
	],
};
